import {Component} from '@angular/core';
import {APP_VERSION} from "../../../../../app.version";
import {environment} from "../../../../../../environments/environment";
import {EnvironmentService} from "../../../../services/environment.service";

@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss']
})
export class VersionComponent {

  constructor(private environment: EnvironmentService) {
  }
  version = APP_VERSION;
  lastModified = document.lastModified;
  releaseStage = this.environment.releaseStage;
}
